import { useEffect, useState } from 'react';
import getConfig from 'src/utils/getConfig';
import UrlConstants, {
  PUBLIC_ROUTES,
  ONBOARDING_PAGE_URL,
  QUICK_LINKS_PAGE_URL,
} from 'src/constants/urlConstants';
import {
  APPROVED_AGENCY_STATUSES,
  ONBOARDING_STARTED_AGENCY_STATUS,
  SUBMITTED_FOR_APPROVAL_STATUS,
} from 'src/constants/agency';
import { isAgencyApproved } from 'src/utils/agencyStatusHelper';
import axiosInstance from 'src/utils/axiosInstance';
import { useHistory } from 'react-router-dom';

const ONBOARDING_PATH = UrlConstants().ONBOARDING_PATH;

const setStartedOnboardingStatus = async () => {
  try {
    await axiosInstance.get(ONBOARDING_PATH, {
      maxRedirects: 0,
    });
  } catch (error) {
    throw new Error(error);
  }
};

export const useOnboarding = (pathname, agencyStatus) => {
  const history = useHistory();
  const isOnboardingPath = pathname.includes(ONBOARDING_PAGE_URL);
  const isPublicPath = PUBLIC_ROUTES.includes(pathname);
  const isOnboardingDisabled = getConfig(
    'applicationMode.agent_portal.onboarding.disabled',
  );

  const isWaitingForApproval = getConfig(
    'applicationMode.agent_portal.onboarding.is_waiting_for_approval',
    APPROVED_AGENCY_STATUSES,
  );

  const [onboardingLoading, setOnboardingLoading] = useState(false);

  useEffect(() => {
    async function onboardingFlow() {
      if (!agencyStatus) {
        return;
      }

      if (
        isAgencyApproved(agencyStatus) ||
        isOnboardingDisabled ||
        isPublicPath
      ) {
        if (isOnboardingPath) {
          history.push(QUICK_LINKS_PAGE_URL);
        }
        return;
      }

      if (
        isWaitingForApproval &&
        agencyStatus === SUBMITTED_FOR_APPROVAL_STATUS
      ) {
        history.push(ONBOARDING_PAGE_URL + '/complete');
        return;
      }

      setOnboardingLoading(true);
      if (ONBOARDING_STARTED_AGENCY_STATUS !== agencyStatus) {
        await setStartedOnboardingStatus();
      }
      setOnboardingLoading(false);

      if (!isOnboardingPath) {
        history.push(ONBOARDING_PAGE_URL);
      }
    }
    onboardingFlow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agencyStatus]);

  return {
    loading: onboardingLoading,
  };
};
